<template>
  <section :id="$style.customer_visual">
    <!-- Look Me -->
    <customer-over-view
      :class="$style.over_view"
      :main_title="'ルックミー'"
      :sub_title="'LookMe'"
      :color="'#403f3f'"
      :link="'/lookme'"
    >
      <template v-slot:viewer>
        <div :class="$style.lookme_pannel">
          <div :class="$style.loop_css">
            <img src="https://www.hideki.co.jp/media/slide.jpg" alt />
            <img src="https://www.hideki.co.jp/media/slide.jpg" alt />
          </div>
        </div>
      </template>
      <template v-slot:explain>
        ご来館のお客様から松井選手やミュージアムに
        <br />まつわる話題などをメッセージボードに
        <br />書いて頂きそのボードを持った
        <br />ご本人様の写真を当ページで楽しんで
        <br />頂く企画です。
      </template>
    </customer-over-view>

    <!-- お客様の声 -->
    <customer-over-view
      :class="$style.over_view"
      :main_title="'お客様の声'"
      :sub_title="'CustomerVoice'"
      :color="'#403f3f'"
      :link="'/customer'"
    >
      <template v-slot:viewer>
        <div :class="$style.customer_voice_pannel">
          <div>{{ customer_voice_item.impression }}</div>
          <div :class="$style.local">{{ customer_voice_item.choice_local }}</div>
        </div>
      </template>
      <template v-slot:explain>
        ミュージアムにご来館されたお客様の
        <br />・ミュージアムの感想
        <br />・ミュージアムに訪れそうと思った動機
        <br />・松井選手へのメッセージ等
        <br />の情報を掲載しております。
      </template>
    </customer-over-view>

    <!-- 夢郵便 -->
    <customer-over-view
      :class="$style.over_view"
      :main_title="'夢郵便'"
      :sub_title="'DreamPost'"
      :color="'#403f3f'"
      :link="'/dreampost'"
    >
      <template v-slot:viewer>
        <div :class="$style.dream_post_pannel">
          <div v-for="item in dream_post_item" :key="item.id">
            <img :class="$style.dream_post_img" :src="item.image" alt />
          </div>
        </div>
      </template>
      <template v-slot:explain>
        〜あなたの夢を、あなたに宛てて〜
        <br />幼き松井秀喜の夢に、今のあなたの夢を
        <br />一枚のハガキに書いて、頑張る自分へ
        <br />記念のハガキを作りませんか？
        <br />送られたハガキを掲載しております。
      </template>
    </customer-over-view>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import CustomerOverView from "@/components/molecules/CustomerOverView.vue";
import { CustomerVoice, DreamPost } from "@/api";

export default Vue.extend({
  name: "CustomerHomeVisual",
  data: function() {
    return {
      test: "",
      customer_voice_item: [],
      dream_post_item: []
    };
  },
  components: {
    CustomerOverView
  },
  mounted() {
    this.getCustomerVoiceItem();
    this.getDreamPostItem("1");
  },
  methods: {
    getDreamPostItem(pagenum) {
      DreamPost.getDreamItem(pagenum).then(({ results }) => {
        this.dream_post_item = results;
      });
    },
    getCustomerVoiceItem() {
      // const now = new Date();
      // const year = now.getFullYear();
      // const month = now.getMonth() + 1;
      CustomerVoice.getLatestCustomerItem(1).then(({ results }) => {
        this.customer_voice_item = results[0];
      });
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #customer_visual {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    background-color: #cce2d5;
    width: 100%;
    z-index: 1;
    position: relative;
    padding: 40px 0px;
    .over_view {
      border-top: 1px solid #000;
    }
    .over_view:nth-child(1) {
      border-top: none !important;
    }
    // LookMe
    .lookme_pannel {
      height: 100%;
      width: 100%;
      overflow: hidden;
      .loop_css {
        display: flex;
        width: 100vw;
        height: 100%;
        left: 50%;
        // margin-left: -50vw;
        overflow: hidden;
        img {
          width: auto;
          height: 100%;
        }
        /* 1つ目の画像 */
        img:first-child {
          -webkit-animation: loop 50s -25s linear infinite;
          animation: loop 50s -25s linear infinite;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          will-change: transform;
        }
        /* 2つ目の画像 */
        img + img {
          -webkit-animation: loop2 50s linear infinite;
          animation: loop2 50s linear infinite;
        }
        @keyframes loop {
          0% {
            -webkit-transform: translateX(100%);
            -ms-transform: translateX(100%);
            transform: translateX(100%);
          }
          to {
            -webkit-transform: translateX(-100%);
            -ms-transform: translateX(-100%);
            transform: translateX(-100%);
          }
        }
        @keyframes loop2 {
          0% {
            -webkit-transform: translateX(0);
            -ms-transform: translateX(0);
            transform: translateX(0);
          }
          to {
            -webkit-transform: translateX(-200%);
            -ms-transform: translateX(-200%);
            transform: translateX(-200%);
          }
        }
      }
    }

    // お客様の声
    .customer_voice_pannel {
      font-size: 14px;
      text-align: center;
      // テープのスタイル
      position: relative;
      background: #fff0cd;
      box-shadow: 0px 0px 0px 5px #fff0cd;
      border: dashed 2px white;
      padding: 0.2em 0.5em;
      color: #454545;
      height: 100%;

      // レイアウト
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      &:after {
        position: absolute;
        content: "";
        right: -7px;
        top: -7px;
        border-width: 0 15px 15px 0;
        border-style: solid;
        border-color: #ffdb88 #cce2d5 #ffdb88;
        box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15);
      }
      p {
        margin: 0;
        padding: 0;
      }
      .local {
        margin-top: 8px;
      }
    }

    // 夢郵便
    .dream_post_pannel {
      display: flex;
      .dream_post_img {
        height: 200px;
        width: 150px;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #customer_visual {
    display: flex;
    justify-content: center;
    background-color: #cce2d5;
    height: 800px;

    // LookMe
    .lookme_pannel {
      height: 100%;
      width: 100%;
      overflow: hidden;
      .loop_css {
        display: flex;
        width: 100vw;
        height: 100%;
        left: 50%;
        margin-left: -50vw;
        overflow: hidden;
        img {
          width: auto;
          height: 100%;
        }
        /* 1つ目の画像 */
        img:first-child {
          -webkit-animation: loop 50s -25s linear infinite;
          animation: loop 50s -25s linear infinite;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          will-change: transform;
        }
        /* 2つ目の画像 */
        img + img {
          -webkit-animation: loop2 50s linear infinite;
          animation: loop2 50s linear infinite;
        }
        @keyframes loop {
          0% {
            -webkit-transform: translateX(100%);
            -ms-transform: translateX(100%);
            transform: translateX(100%);
          }
          to {
            -webkit-transform: translateX(-100%);
            -ms-transform: translateX(-100%);
            transform: translateX(-100%);
          }
        }
        @keyframes loop2 {
          0% {
            -webkit-transform: translateX(0);
            -ms-transform: translateX(0);
            transform: translateX(0);
          }
          to {
            -webkit-transform: translateX(-200%);
            -ms-transform: translateX(-200%);
            transform: translateX(-200%);
          }
        }
      }
    }

    // お客様の声
    .customer_voice_pannel {
      font-size: 14px;
      // テープのスタイル
      position: relative;
      background: #fff0cd;
      box-shadow: 0px 0px 0px 5px #fff0cd;
      border: dashed 2px white;
      padding: 0.2em 0.5em;
      color: #454545;
      height: 100%;
      text-align: center;

      // レイアウト
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      &:after {
        position: absolute;
        content: "";
        right: -7px;
        top: -7px;
        border-width: 0 15px 15px 0;
        border-style: solid;
        border-color: #ffdb88 #cce2d5 #ffdb88;
        box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15);
      }
      p {
        margin: 0;
        padding: 0;
      }
      .local {
        margin-top: 8px;
      }
    }

    // 夢郵便
    .dream_post_pannel {
      display: flex;
      .dream_post_img {
        height: 200px;
        width: 150px;
      }
    }
  }
}
</style>
